import { ref, onMounted } from "vue";
import { usePageContext } from "./usePageContext.js";
function useHydrated() {
  const pageContext = usePageContext();
  const hydrated = ref(pageContext.isClientSide && !pageContext.isHydration);
  if (pageContext.isClientSide && pageContext.isHydration) {
    onMounted(() => {
      hydrated.value = true;
    });
  }
  return hydrated;
}
export {
  useHydrated
};
//# sourceMappingURL=useHydrated.js.map
